import type { ReactNode } from 'react';

type Props = {
  // Accepts a string OR a node so callers can decorate the eyebrow
  // (e.g. a "LIVE" pill next to the section label).
  eyebrow?: ReactNode;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
};

// One header for every page — keeps section labels, titles, subtitles,
// and action buttons visually consistent. Individual pages pass what
// they've got; the layout handles the rest.
export default function PageHeader({ eyebrow, title, subtitle, actions }: Props) {
  return (
    <div className="page-header">
      <div className="page-header-body">
        {eyebrow && <span className="page-eyebrow">{eyebrow}</span>}
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
}
